import { useLayoutEffect, useEffect } from 'react';
var useLayoutEffectIsomorphic = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
export default useLayoutEffectIsomorphic;